"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _IconList = _interopRequireDefault(require("../../../images/IconList"));

var _ImageGallery = _interopRequireDefault(require("../../../images/ImageGallery"));

var _TagList = _interopRequireDefault(require("../../../feedback/TagList"));

var _CommentList = _interopRequireDefault(require("../CommentList"));

var _GuestRatingText = require("../../../../utils/GuestRatingText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-confusing-arrow */
var ReviewContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-0"
})(["display:flex;width:100%;margin-bottom:8px;"]);

var Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-1"
})(["display:flex;flex-direction:column;width:100%;"]);

var CommentsContainer = (0, _styledComponents["default"])(_CommentList["default"]).withConfig({
  componentId: "sc-1wmgooq-2"
})(["display:flex;margin-top:", "px;margin-left:", "px;"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('space.2'));

var DesktopReviewer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-3"
})(["display:none;", "{width:150px;word-break:break-word;display:flex;flex-direction:column;padding:", "px;padding-right:", "px;}"], (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('space.3'));

var MobileReviewer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-4"
})(["display:flex;flex-direction:row;align-items:center;margin-top:", "px;", "{display:none;}"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.lg'));

var SpeechArrow = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-5"
})(["", "{position:absolute;top:", "px;left:-16px;width:0;height:0;border-top:12px solid ", ";border-left:16px solid transparent;}"], (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('space.3'), function (props) {
  return props.backgroundColor || 'rgba(0,0,0,0.05)';
});

var StyledCard = (0, _styledComponents["default"])(_pclnDesignSystem.Card).withConfig({
  componentId: "sc-1wmgooq-6"
})(["position:relative;display:flex;flex-direction:column;padding:", "px;background-color:", ";border:none;"], (0, _themeGet.themeGet)('space.3'), function (props) {
  return props.backgroundColor || 'rgba(0,0,0,0.05)';
});

var BadgeContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-7"
})(["position:absolute;display:flex;top:", "px;right:", "px;font-size:", "px;"], (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('fontSizes.0'));

var ReviewerName = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-8"
})(["display:flex;font-size:", "px;font-weight:", ";", ";padding-right:", "px;margin-right:", "px;margin-bottom:0;", "{border-right:none;padding-right:0;margin-right:0;margin-bottom:", "px;}"], (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('fontWeights.bold'), function (props) {
  return props.description ? 'border-right: 1px solid' : '';
}, (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('space.2'));

var ReviewerDescription = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-9"
})(["display:flex;font-size:", "px;"], (0, _themeGet.themeGet)('fontSizes.0'));

var DateContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-10"
})(["display:flex;color:gray;font-size:", "px;margin-bottom:", "px;"], (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('space.1'));

var StarListContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-11"
})(["display:flex;margin-bottom:", "px;"], (0, _themeGet.themeGet)('space.1'));

var GuestRatingText = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-12"
})(["display:flex;font-weight:", ";margin-bottom:", "px;border-bottom:1px ", " solid;padding-bottom:", "px;"], (0, _themeGet.themeGet)('fontWeights.bold'), (0, _themeGet.themeGet)('space.2'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('space.2'));

var TagListContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-13"
})(["display:flex;margin-top:", "px;"], (0, _themeGet.themeGet)('space.2'));

var ProviderContainer = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-14"
})(["display:flex;align-items:center;justify-content:flex-end;margin-top:", "px;font-size:", "px;"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('fontSizes.0'));

var RatingText = _styledComponents["default"].div.withConfig({
  componentId: "sc-1wmgooq-15"
})(["display:inline-flex;align-items:center;padding:0 ", "px 0 0;font-size:", "px;font-weight:", ";color:", ";"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('fontSizes.3'), (0, _themeGet.themeGet)('fontWeights.bold'), function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.ratingColor)(props);
});

var renderReviewerContent = function renderReviewerContent(reviewerName, reviewerDescription) {
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(ReviewerName, {
    description: reviewerDescription
  }, reviewerName), _react["default"].createElement(ReviewerDescription, null, reviewerDescription));
};

var renderRating = function renderRating(useStars, rating, ratingMax, starColor, ratingColor) {
  return useStars ? _react["default"].createElement(StarListContainer, null, _react["default"].createElement(_IconList["default"], {
    value: rating,
    valueMax: ratingMax,
    color: starColor,
    size: 18
  })) : _react["default"].createElement(RatingText, {
    ratingColor: ratingColor
  }, rating, " / ", ratingMax);
};

var renderTags = function renderTags(tags) {
  return tags && tags.length > 0 && _react["default"].createElement(TagListContainer, null, _react["default"].createElement(_TagList["default"], {
    tags: tags,
    color: "background.light"
  }));
};

var ReviewCard = (0, _react.memo)(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      name = _ref.name,
      description = _ref.description,
      badge = _ref.badge,
      dateReviewed = _ref.dateReviewed,
      rating = _ref.rating,
      ratingMax = _ref.ratingMax,
      starColor = _ref.starColor,
      text = _ref.text,
      maxCharactersBeforeTruncation = _ref.maxCharactersBeforeTruncation,
      images = _ref.images,
      tags = _ref.tags,
      tagBackgroundColor = _ref.tagBackgroundColor,
      provider = _ref.provider,
      comments = _ref.comments,
      useStars = _ref.useStars,
      ratingColor = _ref.ratingColor,
      guestRatingText = _ref.guestRatingText;
  return _react["default"].createElement(ReviewContainer, null, _react["default"].createElement(DesktopReviewer, null, renderReviewerContent(name, description)), _react["default"].createElement(Container, null, _react["default"].createElement(StyledCard, {
    backgroundColor: backgroundColor
  }, _react["default"].createElement(SpeechArrow, {
    backgroundColor: backgroundColor
  }), _react["default"].createElement(DateContainer, null, dateReviewed), badge !== null && _react["default"].createElement(BadgeContainer, null, badge), renderRating(useStars, rating, ratingMax, starColor, ratingColor), _react["default"].createElement(GuestRatingText, null, guestRatingText || (0, _GuestRatingText.getGuestRatingText)(rating, ratingMax)), _react["default"].createElement(_Body["default"], {
    characterLimit: maxCharactersBeforeTruncation,
    mb: 2
  }, text), _react["default"].createElement(_ImageGallery["default"], {
    images: images
  }), renderTags(tags, tagBackgroundColor), _react["default"].createElement(MobileReviewer, null, renderReviewerContent(name, description)), provider && _react["default"].createElement(ProviderContainer, null, provider)), _react["default"].createElement(CommentsContainer, {
    comments: comments
  })));
});
ReviewCard.displayName = 'ReviewCard';
ReviewCard.propTypes = {
  backgroundColor: _propTypes["default"].string,
  name: _propTypes["default"].string,
  description: _propTypes["default"].node,
  badge: _propTypes["default"].node,
  dateReviewed: _propTypes["default"].string,
  rating: _propTypes["default"].number,
  ratingMax: _propTypes["default"].number,
  starColor: _propTypes["default"].string,
  text: _propTypes["default"].node,
  maxCharactersBeforeTruncation: _propTypes["default"].number,
  tags: _propTypes["default"].arrayOf(_propTypes["default"].string),
  tagBackgroundColor: _propTypes["default"].string,
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    thumbnail: _propTypes["default"].string,
    alt: _propTypes["default"].string
  })),
  videos: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    src: _propTypes["default"].string,
    thumbnail: _propTypes["default"].string
  })),
  provider: _propTypes["default"].node,
  comments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    subTitle: _propTypes["default"].string,
    text: _propTypes["default"].node
  })),
  useStars: _propTypes["default"].bool,
  ratingColor: _propTypes["default"].string,
  guestRatingText: _propTypes["default"].string
};
ReviewCard.defaultProps = {
  name: 'Verified Guest',
  useStars: true,
  maxCharactersBeforeTruncation: 240,
  ratingColor: 'text.dark'
};
var _default = ReviewCard;
exports["default"] = _default;